/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/autoCapitalizationFilter.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoPasswordField implements angular.IDirective {
        private filter: angular.IFilterService;
        restrict = "E";
        scope = {
          currentValue: "=ngModel",
          contentKey: "@",
          disabled: "=ngDisabled",
          required: "=ngRequired",
          pattern: "=?ngPattern",
          autocomplete: "=autocomplete"
        };

        template = "<div class=\"meevo_input_wrapper \"><label translate=\"{{::contentKey}}\"></label><div ng-class=\"{'ng-dirty required_red_bubble ' : required}\"></div><input  id=\"{{contentKey + $parent.$index }}\" class='meevo-change-text-field-password' ng-pattern=\"pattern\" autocomplete=\"off\"  ng-class=\"{' red_border_invalid' : (!currentValue && required)}\" type=\"text\" ng-model=\"currentValue\" ng-disabled=\"disabled\" ng-required=\"required\" /></div>";

        constructor($filter: angular.IFilterService) {
          this.filter = $filter;
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            var filter = this.filter;

            element.autocomplete =  Model.Guard.isNothing(scope.autocomplete) ? 'off' : scope.autocomplete;
            //if (!element.css('webkitTextSecurity')) {
            //    element.find(".meevo-change-text-field-password").attr("type", "password");
            //}



            element.on("click", (event: JQueryEventObject) => {
                if (!scope.isDisabled) {
                    let target: any = event.target || event.srcElement;
                    if (target.id === scope.id) {
                        target.select();
                    }
                    event.preventDefault();
                }
            });
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($filter) => {
                return new MeevoPasswordField($filter);
            };

            directive.$inject = ["$filter"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoPasswordField", MeevoPasswordField.factory());
}